
























import { Component, Vue } from 'vue-property-decorator';
import ThemeChanger from './ThemeChanger.vue';
import EnvironmentsChanger from './EnvironmentsChanger.vue';

@Component({
    name: 'SettingsButton',
    components: {
        ThemeChanger,
        EnvironmentsChanger,
    },
})
export default class SettingsButton extends Vue {
    private dialog = false;
}
